 import {apiUrl} from './../constantsSMB/apiUrl';
import api from '../serviceSMB/apiService'
import { Utils } from '../utilSMB/utils';
import { logKafka, logOtherInfo, detailsInfo, catchJSException } from './../serviceSMB/logService';
import { getVZDLInit } from './../serviceSMB/vzdl';

let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;

export const getProductDetailsFromJSON = (dispatch) => {
    var response = require('../containers/productDetails/sampleProductDetailsJson.json');
    dispatch({ type: 'PRODUCTDETAILSFROMJSON', value: response });
    return response;
}

export const getProductDetails = (request,dispatch,visitId,filterProps) => {
    try{
        logOtherInfo(detailsInfo('ProductsPage', visitId, 'getProductDetails', "Inside getProductDetails"));
       var selectedResponse;
   let url = apiUrl().productDetails;
   var selectedOtherItem;
   let obj;
   let item;
   //var prodDetData=window.proddetresp
   dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
//    if(prodDetData !== undefined && prodDetData !== "" && prodDetData !== null )
//     {
//         var response=prodDetData
//         dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
//                 selectedResponse = response.products[0].items.find((object,index) =>{
//                        if(request.productId===object.productId){
//                         obj=object
//                         } 
//                         return obj
//                     })
//                 response.products[0].selectedProd = selectedResponse;
//                 dispatch({ type: 'PRODUCTDETAILSFROMJSON', value: response });
//                 selectedOtherItem= response.relatedItems.map((object,index)=>{
//                    return { ...object, selectedOtherProd:object.items[0],groupId:"G"+ index,modifiedName:Utils.removeSpecialChars(object.name) } 
//                 }) 
//                 dispatch({ type: 'OTHERRELATEDVALUE', value: selectedOtherItem});
//                 window.proddetresp=""
//     }
//    else     
//    {
     api(url, 'POST',JSON.stringify(request)).then(response => {
             if (Utils.isNotNull(response) ) {
                // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } })
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "RESET_LOADER"}}); 
               
                if(filterProps!==null&&filterProps!==undefined){
                    filterProps = filterProps.charAt(0).toUpperCase()+filterProps.slice(1)  

                    for(let i=0 ;i<response.products[0].items.length;i++){
                        if(filterProps === response.products[0].items[i].color){
                         item=response.products[0].items[i]
                        }
                        else{
                         item=response.products[0].items[0]
                        }
                   }
                        response.products[0].selectedProd = item;
                }else{
                 selectedResponse = response.products[0].items.find((object,index) =>{
                       if(request.productId===object.productId){
                        obj=object
                        } 
                        return obj
                    })
                response.products[0].selectedProd = selectedResponse;
                }
                dispatch({ type: 'PRODUCTDETAILSFROMJSON', value: response });
                selectedOtherItem= response.relatedItems.map((object,index)=>{
                   return { ...object, selectedOtherProd:object.items[0],groupId:"G"+ index,modifiedName:Utils.removeSpecialChars(object.name) } 
                }) 
                dispatch({ type: 'OTHERRELATEDVALUE', value: selectedOtherItem});
        }})
        .catch(error => {
            let errorMsg = `MethodName:getProductDetails,errorMessage:${error.message}`;
            logKafka("ERROR", "ProductsDetailsPage", errorMsg, getErrorLogUrl, "applogs", visitId);
            // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } })
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "RESET_LOADER"}}); 
            getVZDLInit(visitId,"","","","","","",error.message);
        });
    }catch (ex) {
        catchJSException('ProductsDetailsPage', visitId, 'getProductDetails', ex);
      }
    }

export const storeProductId = (dispatch,request) => {
    dispatch({ type: 'STOREPRODUCTID', value: request });
  }
  export const storeColorClick = (dispatch,request) => {
    dispatch({ type: 'STORECOLORCLICK', value: false });
  }

  export const productDetailsValue= (request,dispatch) => {
    dispatch({ type: 'PRODUCTDETAILSFROMJSON', value: request});
    return request;
   }  

   export const otherRelatedValue= (request,dispatch) => {
    dispatch({ type: 'OTHERRELATEDVALUE', value: request});
    return request;
   }  
   